import { createReducer, on } from '@ngrx/store';
import { BookingType, InvoiceHistory, InvoiceHistoryRequestData, InvoiceSortOptions, InvoiceSummaryAvisResponse, InvoiceSummaryDetailResponse, OrderType } from '../custom-user-payments.models';
import * as CustomUserPaymentsActions from './custom-user-payments-actions';

export const customUserPaymentsFeatureKey = 'customUserPayments';

export const CUSTOM_USER_PAYMENTS = 'customUserPayments';
export const CUSTOM_USER_PAYMENTS_FILTERS = 'customUserPaymentsFilters';
export const CUSTOM_USER_PAYMENTS_DETAILS = 'customUserPaymentsDetails';
export const CUSTOM_USER_PAYMENTS_AVIS = 'customUserPaymentsAvis';

const todaysDate: Date = new Date();

export interface CustomUserPaymentsState {
    [CUSTOM_USER_PAYMENTS]: {
      invoiceOverview: InvoiceHistory;
      isLoading: boolean;
      error?: Error;
    };
    [CUSTOM_USER_PAYMENTS_FILTERS]: {
      invoiceHistoryRequestData?: InvoiceHistoryRequestData;
      backToOverview?: boolean;
    };
    [CUSTOM_USER_PAYMENTS_DETAILS]: {
      invoiceDetails: InvoiceSummaryDetailResponse;
      isLoading: boolean;
      error?: Error;
    };
    [CUSTOM_USER_PAYMENTS_AVIS]: {
      invoiceAvis: InvoiceSummaryAvisResponse;
      isLoading: boolean;
      error?: Error;
    };
}

export const initialState: CustomUserPaymentsState = {
    [CUSTOM_USER_PAYMENTS]: {
      invoiceOverview: null,
      isLoading: false,
      error: null,
    },
    [CUSTOM_USER_PAYMENTS_FILTERS]: {
      invoiceHistoryRequestData: {
        dateFrom: new Date(todaysDate).setDate(todaysDate.getDate() - 365).toString(),
        dateTo: new Date().toString(),
        invoiceNumber: '',
        articleNumber: '',
        adviceNumber: '',
        onlyOpen: true,
        referenceNumber: '',
        amountFrom: '',
        amountTo: '',
        orderType: OrderType[OrderType.ALL],
        bookingType: BookingType[BookingType.ALL],
        sortDirection: 'desc',
        sortOption:InvoiceSortOptions[InvoiceSortOptions.invoiceDate],
      },
      backToOverview: false,
    },
    [CUSTOM_USER_PAYMENTS_DETAILS]: {
      invoiceDetails: null,
      isLoading: false,
      error: null,
    },
    [CUSTOM_USER_PAYMENTS_AVIS]: {
      invoiceAvis: null,
      isLoading: false,
      error: null,
    }
};

export const customUserPaymentsReducer = createReducer(
    initialState,
    on(CustomUserPaymentsActions.getUserPayments,
      (state) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS]: {
            invoiceOverview: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomUserPaymentsActions.getUserPaymentsSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS]: {
          invoiceOverview: action.invoiceOverview,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomUserPaymentsActions.getUserPaymentsFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS]: {
          invoiceOverview: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(CustomUserPaymentsActions.searchUserPayments,
      (state,action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS]: {
          invoiceOverview: null,
          isLoading: true,
          error: null,
        },
        [CUSTOM_USER_PAYMENTS_FILTERS]: {
          invoiceHistoryRequestData: action.invoiceHistoryRequestData,
        },
    })),
    on(CustomUserPaymentsActions.searchUserPaymentsSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS]: {
          invoiceOverview: action.invoiceOverview,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomUserPaymentsActions.searchUserPaymentsFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS]: {
          invoiceOverview: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(CustomUserPaymentsActions.sortUserPayments,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_FILTERS]: {
          invoiceHistoryRequestData: action.invoiceHistoryRequestData,
        },
      })
    ),
    //******************************************************
    on(CustomUserPaymentsActions.backToUserPayments,
      (state) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_FILTERS]: {
          invoiceHistoryRequestData: state[CUSTOM_USER_PAYMENTS_FILTERS].invoiceHistoryRequestData,
          backToOverview: true,
        },
      })
    ),
    on(CustomUserPaymentsActions.resetBackToUserPayments,
      (state) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_FILTERS]: {
          backToOverview: false,
        },
      })
    ),
    //******************************************************
    on(CustomUserPaymentsActions.getUserPaymentsDetails,
      (state) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_DETAILS]: {
            invoiceDetails: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomUserPaymentsActions.getUserPaymentsDetailsSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_DETAILS]: {
          invoiceDetails: action.invoiceDetails,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomUserPaymentsActions.getUserPaymentsDetailsFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_DETAILS]: {
          invoiceDetails: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
     //******************************************************
     on(CustomUserPaymentsActions.getUserPaymentsAvis,
      (state) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_AVIS]: {
            invoiceAvis: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomUserPaymentsActions.getUserPaymentsAvisSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_AVIS]: {
          invoiceAvis: action.invoiceAvis,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomUserPaymentsActions.getUserPaymentsAvisFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_USER_PAYMENTS_AVIS]: {
          invoiceAvis: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
);